import React, { useState } from 'react';
import { Box, Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import {
    IForgotPasswordMutationVariables,
    useForgotPasswordMutation,
} from 'graphql/types';
import { ForgotPasswordForm } from 'auth/components/forms/ForgotPasswordForm';
import { useSnackbarContext } from 'common/context';
import { Button } from 'common/components/buttons/Button';
import { getIntlPath } from 'common/utils';

import { BaseAuthPage } from './BaseAuthPage';

export const ForgotPasswordPage = () => {
    const { t } = useTranslation();

    const [submitted, setSubmitted] = useState(false);
    const { setSnackbarState } = useSnackbarContext();
    const history = useHistory();
    const [requestPasswordReset, { loading }] = useForgotPasswordMutation({
        update: () => {
            setSnackbarState({
                message: t('messages.forgotPasswordMailSent'),
                variant: 'success',
            });

            setSubmitted(true);
        },
        onError: (error) => {
            setSnackbarState({
                message: error.message,
                variant: 'error',
            });
        },
    });

    const handleSubmit = (values: IForgotPasswordMutationVariables) => {
        requestPasswordReset({ variables: values });
    };

    return (
        <BaseAuthPage>
            {submitted && (
                <Box width="100%">
                    <Typography color="primary" variant="h2">
                        {t('account.forgotPassword.submitted')}
                    </Typography>

                    <Typography
                        color="textSecondary"
                        component="span"
                        variant="body2"
                    >
                        {t('account.forgotPassword.pageDescriptionSubmitted')}
                    </Typography>

                    <Box mt={7}>
                        <Button
                            fullWidth
                            onClick={() => history.push(getIntlPath('login'))}
                        >
                            {t('account.forgotPassword.buttonBack')}
                        </Button>
                    </Box>
                </Box>
            )}

            {!submitted && (
                <ForgotPasswordForm loading={loading} onSubmit={handleSubmit} />
            )}
        </BaseAuthPage>
    );
};
